module.exports = __webpack_public_path__ + "static/media/bandas-dorado-borde.eda7d577.png";